module.exports = __webpack_public_path__ + "static/media/SamBackground.27114c61.png";